var render = function render(){var _vm=this,_c=_vm._self._c;return _c('option',{attrs:{"disabled":_vm.disabled,"hidden":_vm.hidden},domProps:{"value":_vm.value,"selected":_vm.selected}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }